import LegalPage from "./LegalPage";
import {
  TERMS, PRIVACY, COOKIES, REFUND, DISCLAIMER,
  ACCEPTABLE_USE, BUSINESS_TERMS, TRUST_SAFETY,
  CUSTOMER_TERMS, DATA_DELETION, REVIEWS_POLICY,
  ENHANCED_SAFETY,
} from "@/content/legal";

export const TermsPage          = () => <LegalPage slug="terms"          content={TERMS} />;
export const PrivacyPage        = () => <LegalPage slug="privacy"        content={PRIVACY} />;
export const CookiesPage        = () => <LegalPage slug="cookies"        content={COOKIES} />;
export const RefundPage         = () => <LegalPage slug="refund"         content={REFUND} />;
export const DisclaimerPage     = () => <LegalPage slug="disclaimer"     content={DISCLAIMER} />;
export const AcceptableUsePage  = () => <LegalPage slug="acceptable-use" content={ACCEPTABLE_USE} />;
export const BusinessTermsPage  = () => <LegalPage slug="business-terms" content={BUSINESS_TERMS} />;
export const TrustSafetyPage    = () => <LegalPage slug="trust-safety"   content={TRUST_SAFETY} />;
export const CustomerTermsPage  = () => <LegalPage slug="customer-terms" content={CUSTOMER_TERMS} />;
export const DataDeletionPage   = () => <LegalPage slug="data-deletion"  content={DATA_DELETION} />;
export const ReviewsPolicyPage  = () => <LegalPage slug="reviews-policy" content={REVIEWS_POLICY} />;
export const EnhancedSafetyPage = () => <LegalPage slug="enhanced-safety" content={ENHANCED_SAFETY} />;
